import RegulationWrapper from 'components/Regulation/RegulationWrapper';
import React from 'react';
import { Container } from 'ui';

type ContentTextProps = {
    data: any
};
const ContentText: React.FC<ContentTextProps> = ({ data }) => {
    return (
        <Container>
            <RegulationWrapper data={data} />
        </Container>
    );
};
export default ContentText;
